import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedCross = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: "1pt",
	height: "1pt",
	viewBox: "0 0 1 1",
	x: -1,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "surface1",
		transform: "translate(0,-0.1)",
		children: [/* @__PURE__ */ _jsx("path", {
			style: {
				stroke: "none",
				fillRule: "nonzero",
				fill: "rgb(100%,100%,100%)",
				fillOpacity: 1
			},
			d: "M 0.8125 0.5 C 0.8125 0.671875 0.671875 0.8125 0.5 0.8125 C 0.328125 0.8125 0.1875 0.671875 0.1875 0.5 C 0.1875 0.328125 0.328125 0.1875 0.5 0.1875 C 0.671875 0.1875 0.8125 0.328125 0.8125 0.5 Z M 0.8125 0.5 "
		}), /* @__PURE__ */ _jsx("path", {
			style: {
				stroke: "none",
				fillRule: "nonzero",
				fill: "rgb(80.392157%,23.921569%,31.372549%)",
				fillOpacity: 1
			},
			d: "M 0.5 0.1875 C 0.328125 0.1875 0.1875 0.328125 0.1875 0.5 C 0.1875 0.671875 0.328125 0.8125 0.5 0.8125 C 0.671875 0.8125 0.8125 0.671875 0.8125 0.5 C 0.8125 0.417969 0.78125 0.335938 0.722656 0.277344 C 0.664062 0.21875 0.582031 0.1875 0.5 0.1875 Z M 0.65625 0.613281 L 0.613281 0.65625 L 0.5 0.542969 L 0.386719 0.65625 L 0.34375 0.613281 L 0.457031 0.5 L 0.34375 0.386719 L 0.386719 0.34375 L 0.5 0.457031 L 0.613281 0.34375 L 0.65625 0.386719 L 0.542969 0.5 Z M 0.65625 0.613281 "
		})]
	})
});
export default SvgRedCross;
